import { useState } from 'react';
import ButtonText from '../button/button-text/ButtonText';
import ConfirmModal from '../confirm-modal/ConfirmModal';
import RoundedButtonAction from '../button/rounded-button-action/RoundedButtonAction';
import RoundedButtonPrimary from '../button/rounded-button-primary/RoundedButtonPrimary';
import RoundedButtonSecondary from '../button/rounded-button-secondary/RoundedButtonSecondary';

const ConfirmButton = ({
    className,
    children,
    title,
    message,
    cancelText,
    successText,
    onClickSuccess,
    skipConfirmation,
    buttonType,
}) => {
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const onClick = () => {
        if (skipConfirmation) {
            onClickSuccess();
        } else {
            setConfirmModalOpen(true);
        }
    };

    const handleClickSuccess = () => {
        setConfirmModalOpen(false);
        onClickSuccess();
    };

    const Button = getButtonByType(buttonType);

    return (
        <>
            <Button className={className} onClick={onClick}>
                {children}
            </Button>
            <ConfirmModal
                isOpen={confirmModalOpen}
                title={title || 'Bekreft valget ditt'}
                message={message || 'Er du sikker?'}
                cancelText={cancelText || 'Avbryt'}
                successText={successText || 'Ja'}
                onClickSuccess={handleClickSuccess}
                onClickCancel={() => setConfirmModalOpen(false)}
            />
        </>
    );
};

export default ConfirmButton;

function getButtonByType(buttonType) {
    let Button;
    switch (buttonType) {
        case 'action':
            Button = RoundedButtonAction;
            break;
        case 'primary':
            Button = RoundedButtonPrimary;
            break;
        case 'secondary':
            Button = RoundedButtonSecondary;
            break;
        case 'text':
            Button = ButtonText;
            break;
        default:
            Button = RoundedButtonPrimary;
            break;
    }
    return Button;
}
